import { ListItem, styled } from '@mui/material';

export const DialogInfoListItem = styled(ListItem)({
  display: 'list-item',
  paddingLeft: '4px',
}); 